// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3pSYQ","amount":"Amount_amount__2eAOV","tip":"Amount_tip__2zfC7","tipHeader":"Amount_tipHeader__1Swls","tipsWrap":"Amount_tipsWrap__GJ94a"};